import React from 'react';
import { Icon, Picture } from 'components';
import { formatDateString, formatPhoneTable } from 'utils/formatString';

export const TABLE_TYPES = {
  CALL: 1,
  SMS: 2,
  INTERNET: 3,
};

export const TABLE_CONFIGS = {
  [TABLE_TYPES.CALL]: {
    desktopColumns: [
      {
        title: 'Время',
        modify: 'img',
        colSize: 'md',
        textColor: 'grey50',
        data: (col) => (
          <>
            <Picture defaultImage={`https://static.beeline.ru/upload/images/detalization/${col.filterId}.svg`} />
            <span>{formatDateString(col.dateTime, 'HH:mm')}</span>
          </>
        ),
      },
      {
        title: 'Услуга',
        colSize: 'lg',
        data: (col) => col.operation,
      },
      {
        title: 'Номер',
        colSize: 'md',
        data: formatPhoneTable,
      },
      {
        title: 'Баланс',
        colSize: 'md',
        textColor: 'grey50',
        data: (col) => col.balances[0].balanceText,
      },
      {
        title: 'Длительность',
        colSize: 'md',
        data: (col) => col.formattedTraffic,
      },
      {
        title: 'Сумма',
        colSize: 'lg',
        data: (col) => col.balances[0].unitCode === 'CURRENCY' ? `${col.balances[0].valueChange} ₽` : col.formattedTraffic,
      },
    ],
    mobileColumns: {
      icon: {
        classes: ['table-body__logo'],
        data: (col) => <Picture defaultImage={`https://static.beeline.ru/upload/images/detalization/${col.filterId}.svg`} />,
      },
      title: {
        data: (col) => col.operation,
      },
      price: {
        classes: ['table--text-right'],
        color: 'gray50',
        data: (col) => col.formattedTraffic,
      },
      description: {
        data: formatPhoneTable,
      },
      time: {
        classes: ['table--text-right'],
        color: 'gray50',
        data: (col) => formatDateString(col.dateTime, 'HH:mm'),
      },
    },
    dateGetter: (col) => new Date(`${col.dateTime}`),
    columnFormatter: (x) => ((x === '' || x === undefined) ? '—' : x),
  },
  [TABLE_TYPES.SMS]: {
    desktopColumns: [
      {
        title: 'Время',
        modify: 'img',
        colSize: 'md',
        textColor: 'grey50',
        data: (col) => (
          <>
            <Picture defaultImage={`https://static.beeline.ru/upload/images/detalization/${col.filterId}.svg`} />
            <span>{formatDateString(col.dateTime, 'HH:mm')}</span>
          </>
        ),
      },
      {
        title: 'Услуга',
        colSize: 'md',
        data: (col) => col.operation,
      },
      {
        title: 'Номер',
        colSize: 'md',
        data: formatPhoneTable,
      },
      {
        title: 'Баланс',
        textColor: 'grey50',
        colSize: 'md',
        data: (col) => col.balances[0].balanceText,
      },
      {
        title: 'Сумма',
        colSize: 'sm',
        data: (col) => col.balances[0].unitCode === 'CURRENCY' ? `${col.balances[0].valueChange} ₽` : col.formattedTraffic,
      },
    ],
    mobileColumns: {
      icon: {
        classes: ['table-body__logo'],
        data: (col) => <Picture defaultImage={`https://static.beeline.ru/upload/images/detalization/${col.filterId}.svg`} />,
      },
      operation: {
        data: (col) => col.operation,
      },
      price: {
        classes: ['table--text-right'],
        color: 'gray50',
        data: (col) => col.balances[0].unitCode === 'CURRENCY' ? `${col.balances[0].valueChange} ₽` : col.formattedTraffic,
      },
      title: {
        data: formatPhoneTable,
      },
      time: {
        classes: ['table--text-right'],
        color: 'gray50',
        data: (col) => formatDateString(col.dateTime, 'HH:mm'),
      },
    },
    dateGetter: (col) => new Date(`${col.dateTime}`),
    columnFormatter: (x) => ((x === '' || x === undefined) ? '—' : x),
  },
  [TABLE_TYPES.INTERNET]: {
    desktopColumns: [
      {
        title: 'Время',
        modify: 'img',
        colSize: 'md',
        textColor: 'grey50',
        data: (col) => (
          <>
            <Picture defaultImage={`https://static.beeline.ru/upload/images/detalization/${col.filterId}.svg`} />
            <span>{formatDateString(col.dateTime, 'HH:mm')}</span>
          </>
        ),
      },
      {
        title: 'Услуга',
        colSize: 'sm',
        data: (col) => col.operation,
      },
      {
        title: 'Баланс',
        textColor: 'grey50',
        colSize: 'sm',
        data: (col) => col.balances[0].balanceText,
      },
      {
        title: 'Объем услуг',
        colSize: 'md',
        data: (col) => col.formattedTraffic,
      },
      {
        title: 'Сумма',
        colSize: 'sm',
        data: (col) => col.balances[0].unitCode === 'CURRENCY' ? `${col.balances[0].valueChange} ₽` : col.formattedTraffic,
      },
    ],
    mobileColumns: {
      icon: {
        classes: ['table-body__logo'],
        data: (col) => <Picture defaultImage={`https://static.beeline.ru/upload/images/detalization/${col.filterId}.svg`} />,
      },
      title: {
        data: (col) => col.operation,
      },
      price: {
        classes: ['table--text-right'],
        color: 'gray50',
        data: (col) => col.formattedTraffic,
      },
      description: {
        data: () => (''),
      },
      time: {
        classes: ['table--text-right'],
        color: 'gray50',
        data: (col) => formatDateString(col.dateTime, 'HH:mm'),
      },
    },
    dateGetter: (col) => new Date(`${col.dateTime}`),
    columnFormatter: (x) => ((x === '' || x === undefined) ? '—' : x),
  },
};
